export default "__VITE_ASSET__C7S2mH3n__"